<template>
  <generic-modal :modal-key="'unsubscribeSms'"
                 :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_do_you_want }}</h1>
      <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
      <p>{{ getTranslations.home_modals_unsubscribe_if_you_unsubscribe }}</p>
      <div class="modal_middle_title">
        <h1>{{ getTranslations.home_modals_unsubscribe_do_you_want }}</h1>
      </div>
      <div class="modal__footer"><span class="terms ">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_unsub_unsubscribesms_modal') }}
        </span>
      </div>
    </template>
  </generic-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  name: 'unsubscribe-sms',
  components: { GenericModal },
  computed: {
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
  watch: {
    '$route'() {
      // Emit a close event whenever the route changes
      this.$emit('close');
    }
  },
  beforeRouteLeave(to, from, next) {
    // Emit a close event before leaving the current route
    this.$emit('close');
    next();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/UnsubscribeSms.vue